// Chat Module Types

export type ChatType = 'direct' | 'group' | 'team' | 'family';

export type MessageType = 'text' | 'image' | 'file' | 'video' | 'audio' | 'system' | 'poll';

export interface Chat {
  id: string;
  type: ChatType;
  weekend_id?: string;
  team_id?: string;
  name?: string;
  description?: string;
  avatar_url?: string;
  is_read_only: boolean;
  created_at: string;
  created_by?: string;
  last_message_at?: string;
  updated_at?: string;
  
  // Joined data
  participants?: ChatParticipant[];
  last_message?: Message;
  unread_count?: number;
  other_user?: Profile; // For direct chats
}

export interface ChatParticipant {
  id: string;
  chat_id: string;
  user_id: string;
  is_admin: boolean;
  is_muted: boolean;
  last_read_at?: string;
  last_read_message_id?: string;
  joined_at: string;
  left_at?: string;
  
  // Joined data
  user?: Profile;
}

export interface Message {
  id: string;
  chat_id: string;
  sender_id: string;
  content?: string;
  type: MessageType;
  file_url?: string;
  file_name?: string;
  file_type?: string;
  file_size?: number;
  game_reference?: any;
  reply_to_id?: string;
  mentioned_user_ids?: string[];
  is_edited: boolean;
  is_deleted: boolean;
  created_at: string;
  edited_at?: string;
  metadata?: Record<string, any>;
  
  // Joined data
  sender?: Profile;
  reply_to?: Message;
  reactions?: MessageReaction[];
}

export interface MessageReaction {
  id: string;
  message_id: string;
  user_id: string;
  emoji: string;
  created_at: string;
  
  // Joined data
  user?: Profile;
}

export interface TypingIndicator {
  chat_id: string;
  user_id: string;
  updated_at: string;
  
  // Joined data
  user?: Profile;
}

export interface Profile {
  id: string;
  full_name?: string;
  nickname?: string;
  avatar_url?: string;
  email?: string;
  is_dependent?: boolean;
}

export interface ChatWithDetails extends Chat {
  participants: ChatParticipant[];
  last_message?: Message;
  unread_count: number;
  is_muted?: boolean; // From user's chat_participants record
}

export interface CreateChatParams {
  type: ChatType;
  name?: string;
  description?: string;
  avatar_url?: string;
  participant_ids: string[];
  weekend_id?: string;
  team_id?: string;
}

export interface SendMessageParams {
  chat_id: string;
  content?: string;
  type?: MessageType;
  file_url?: string;
  file_name?: string;
  file_type?: string;
  file_size?: number;
  reply_to_id?: string;
  mentioned_user_ids?: string[];
}

export interface FileUploadResult {
  chatFileUrl: string;
  galleryFileUrl: string;
  fileName: string;
  fileType: string;
  fileSize: number;
}

export interface ChatNotification {
  id: string;
  chat_id: string;
  chat_name: string;
  chat_avatar?: string;
  sender_name: string;
  sender_avatar?: string;
  message_content: string;
  message_type: MessageType;
  timestamp: string;
}

